import React from 'react';
import {
    CriticalErrorMsg,
    GenericErrorMsg,
    GlobalDialogs,
    PromptToCompleteKyc,
    SessionExpiredMsg,
} from '~/entities/dialogs';
import {SusActivityDialog} from '~/features/two-factor';

const dialogs = [
    //
    CriticalErrorMsg,
    GenericErrorMsg,
    PromptToCompleteKyc,
    SessionExpiredMsg,
    SusActivityDialog,
];

export function AppModals() {
    return <GlobalDialogs dialogs={dialogs} />;
}
